import { styled } from '@mui/material';
import { Accordion } from '@totalsoft/rocket-ui';

export const AccordionWrapper = styled(Accordion)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  margin: `${theme.spacing(0.5)} !important`,
  '&::before': {
    display: 'none'
  },
  '& .Mui-expanded': {
    color: theme.palette.error.main,
    '& .MuiTypography-root': {
      color: theme.palette.error.main
    }
  },
  '& .MuiAccordionSummary-content > h6': {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '1rem',
    width: '100%',
    '&:hover': {
      color: theme.palette.error.main
    }
  },
  width: '100%'
}));
